<template>
  <div class="home">
    <div class="imgbox">
      <!-- 最外层div设置为绝对定位 -->
      <div style="position: absolute;">
        <img class="box-img" src="../assets/banner.png">
        <div class="box-font">盛鑫招标</div>
      </div>
    </div>
      <article class="newhome" v-cloak  style="padding-bottom: 100px;">
      <div style="display: flex;margin-top: 40px;">
        <div>
          <leftmenu :value='Category' :list='about_menulist' @datashow =contentshow ></leftmenu>
        <!--登录-->       
        </div>
        <div class="mr-border">
        <div v-html =content></div>
      </div>
      
      </div>      
    </article>
  </div>
</template>
<script>
import leftmenu from "../components/leftmenu.vue";
export default {
  name: "about",
  components: { leftmenu },
  data: function() {
    return {
      about_menulist: [
      ],
      content: "",
      Category: ''
    };
  },
  updated() {
  },
  created() {
    var that =this;
    that.Category = this.$route.query.id;
    var menulist = JSON.parse(window.localStorage.getItem("menulist")) || [];    
    that.about_menulist = menulist.filter(function(item){
            return item.Word_Group_Key == 'ColumnType' && item.Word_Value > 0
    }); 
       
    if(!that.Category)that.contentshow(that.about_menulist[0]);
    else{
      var list = that.about_menulist.filter(function(item){
          return item.Word_Value == that.Category
      });
      if(list.length > 0){
        that.getData();    
      }
    }
  },
  watch: {
    $route: async function(to, from) {
      var that =this;
      that.Category = to.query.id;
      if(!that.Category)that.contentshow(that.about_menulist[0]);
      else{
      var list = that.about_menulist.filter(function(item){
          return item.Word_Value == that.Category
      });
      if(list.length > 0){
        that.getData();    
      }
    }
    }
  },
  mounted() {
     
  },
  methods: {   
    getData() {
      var that = this;
      this.$api.get("/Column/"+ that.Category, null, r => {
        that.content = r.response.Content;
      });
    },
    contentshow(item){
      var that = this;
      that.Category = item.Word_Value;
      that.getData();
      return false;
    }
  },
  computed: {
    
  }
};
</script>

<style>
.mr-border{
  margin-left: 20px;
  border: 1px solid #CCCCCC;
  padding: 35px 35px;
  width:100%; 
}
.frame-border{
  width: 204px;  
  border: 1px solid #EEEEEE;
}
.lmenu{
  display: flex;
  justify-content: space-between;
  align-items: center;
  color:#222222;
  font-size: 18px;
}
</style>